module.exports = __webpack_public_path__ + "img/znzll.f7658515.jpg";